// Types
import { VISIBLE_CONNECTION_STATUS_CHANGED, VisibleConnectionStatus } from './visibleConnectionStatusTypes';

export const visibleConnectionStatusChanged = (status: VisibleConnectionStatus) => ({
    type: VISIBLE_CONNECTION_STATUS_CHANGED,
    status,
});
